import { Component, computed, input } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';

import { HorizontalLogoComponent } from './horizontal-logo.component';
import { SygnetComponent } from './sygnet.component';
import { VerticalLogoComponent } from './vertical-logo.component';

@Component({
  selector: 'r2e-logo',
  imports: [NgComponentOutlet],
  templateUrl: './logo.component.html',
  styles: [`
    :host {
      &.dark {
        color-scheme: dark;
      }
      
      &.light {
        color-scheme: light;
      }
    }
  `],
  host: {
    '[class.dark]': 'forcedTheme() === "dark"',
    '[class.light]': 'forcedTheme() === "light"',
  }
})
export class LogoComponent {
  forcedTheme = input<'dark' | 'light'>();
  variant = input<'horizontal-logo' | 'vertical-logo' | 'sygnet'>('sygnet');

  private logoComponentsMap = new Map([
    ['horizontal-logo', HorizontalLogoComponent],
    ['vertical-logo', VerticalLogoComponent],
    ['sygnet', SygnetComponent]
  ]);

  logoComponent = computed(() => this.logoComponentsMap.get(this.variant()) ?? null);
}
